import { Typography } from '@mui/material'
import { colorTokens } from '../../../../shared/styles/theme'

/** 項目ペインの段の見出し（保険・患者・処方内容・疑義アラート…）。12px / fg.faint の 1 行 */
export const Heading = ({ children }: { children: string }) => (
  <Typography
    sx={{ mt: 2.5, mb: 0.5, fontSize: 12, color: colorTokens.fg.faint }}
  >
    {children}
  </Typography>
)
